module.exports = __webpack_public_path__ + "img/icon-arrow.1895e861.svg";